module.exports = __webpack_public_path__ + "img/庙会详情(明清宫苑)_02.2bfbc857.jpg";